import React, { FC, FormEvent, ReactNode } from 'react';
import cn from 'classnames';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '../icons/Close';

export interface IProps extends Omit<DialogProps, 'onSubmit'> {
  title?: string;
  actions?: ReactNode;
  footer?: ReactNode;
  hasCloseButton?: boolean;
  onClose?: () => void;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
}

const Modal: FC<IProps> = ({ title, children, actions, hasCloseButton, onClose, onSubmit, fullWidth = true, footer, ...rest }) => {

  const renderedFormPart = (
    <>
      { !!children &&
          <DialogContent>
            { children }
          </DialogContent>
      }
      { !!actions &&
          <DialogActions disableSpacing>
            { actions }
          </DialogActions>
      }
    </>
  );

  return (
    <Dialog { ...{ ...rest, fullWidth, onClose } } >
      { !!title &&
          <DialogTitle> { title }</DialogTitle>
      }
      { hasCloseButton &&
          <IconButton className={ cn('modalCloseIcon', { invert: !title }) } color={ 'primary' } onClick={ onClose }>
            <CloseIcon fontSize="inherit" />
          </IconButton>
      }
      { typeof onSubmit === 'function'
        ? (
          <form onSubmit={ onSubmit }>
            { renderedFormPart }
          </form>)
        : renderedFormPart
      }
      { !!footer &&
        <div className="modalFooter"> { footer } </div>
      }
    </Dialog>
  );
};

export default Modal;
